module.exports = __webpack_public_path__ + "img/badge_eatinerari.a570a62d.jpg";